import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FaqList = ({ faqs, testidPrefix = "faq" }) => (
  <Accordion type="single" collapsible className="w-full">
    {faqs.map((f, i) => (
      <AccordionItem
        key={i}
        value={`item-${i}`}
        data-testid={`${testidPrefix}-item-${i}`}
        className="border-b border-charcoal/15"
      >
        <AccordionTrigger className="py-6 text-left font-heading text-lg font-black text-charcoal hover:text-brand-red hover:no-underline md:text-xl">
          {f.q}
        </AccordionTrigger>
        <AccordionContent className="pb-6 font-body text-base leading-relaxed text-fog">
          {f.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
